import {InitialRequestUrl, RequestInfo} from "@repo/shared-core";
import {executeExternalScript} from "@repo/util-external-script";

// This contains the OneTrust script that loads the cookie consent banner.
// Doing so puts us in compliance with the EU Privacy Directive, which in turn
// allows us to sell products (e.g. Khanmigo) in that market.
export function loadCookieConsent() {
    if (
        !RequestInfo.isE2E &&
        !RequestInfo.isBot &&
        // don't show in the dev server, since devs clear cookies often
        // and this modal can get annoying
        !RequestInfo.IS_DEV_SERVER &&
        // don't show in embedded views, like Khanmigo activities in the
        // mobile app
        !RequestInfo.embedded &&
        // the below three URLs are for embeds, but don't pass through
        // RequestInfo.embedded properly, so we need to check them
        // separately
        InitialRequestUrl.pathname !== "/embed_video" &&
        InitialRequestUrl.pathname !== "/perseus/frame" &&
        InitialRequestUrl.pathname !== "/perseus/exercise-frame"
    ) {
        // This script URL and the dataDomainScript ID are provided by
        // OneTrust (access through app.onetrust.com).
        executeExternalScript(
            "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
            {
                dataDomainScript: "757b7941-c87a-4c66-8f35-eed366c64b57",
            },
        );
        // @ts-expect-error - TS2339 - Property 'OptanonWrapper' does not exist on type 'Window & typeof globalThis'.
        window.OptanonWrapper = () => {};
    }
}
